// extracted by mini-css-extract-plugin
module.exports = {"modal":"styles_modal__3J6I-","content":"styles_content__cihWR"};